import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export interface ProtectedRoutePropsFromDispatch {
  getLoginStatus: () => void;
}

export interface ProtectedRoutePropsFromState {
  isLoggedIn: boolean;
}

interface ChildComponentProps {
  component: React.ComponentType<any>;
}

class ProtectedRoute extends React.Component<
  RouteProps &
    ChildComponentProps &
    ProtectedRoutePropsFromState &
    ProtectedRoutePropsFromDispatch
> {
  public componentDidMount() {
    this.props.getLoginStatus();
  }

  public render() {
    const { isLoggedIn, component: Component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={props =>
          isLoggedIn ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{ pathname: '/login', state: { referrer: props.location } }}
            />
          )
        }
      />
    );
  }
}

export default ProtectedRoute;
